import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Box,
    useTheme,
} from '@mui/material';

const StackedBarGraph = ({ ...props }) => {
    const options = {
        plugins: {
            title: {
                display: true,
            },
        },
        responsive: true,
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };

    return (
        <Box
            sx={{
                height: '100%',
                width: '100%'
            }}
            className={!props.data ? 'display-center' : ''}
        >
            <Bar options={options} data={props.data} />;
        </Box>
    );


}

export default StackedBarGraph;